<template>
  <div class="w-100 d-flex justify-content-between flex-column">
    <div class="text-center pt-5">
      <h1>Samenwerkingen met onder andere:</h1>
    </div>

    <transition name="fade-up">
      <div class="row p-5" v-if="showPartners">
        <div
          class="col-md-4"
          v-for="partner in partners.slice(0, limit)"
          :key="partner.id"
        >
          <div class="d-flex justify-content-center mb-5">
            <img
              :src="partner.logo"
              class="img-thumbnail img-logo"
              :alt="partner.name"
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { fetchPartners } from '@/public/api';

export default {
  name: 'Partners',
  data() {
    return {
      partners: [],
      showPartners: false,
      limit: false,
    };
  },
  methods: {
    async fetchPartners() {
      this.showPartners = false;
      const response = await fetchPartners();
      this.partners = response.data;
      setTimeout(() => { this.showPartners = true; }, 250);
      setTimeout(this.fetchPartners, 5000);
    },
  },
  created() {
    this.fetchPartners();
    this.limit = this.$route.query.limit || 6;
  },
};
</script>

<style scoped>
.img-logo {
  max-height: 200px;
  width: auto;
}
</style>
